/**
 * Load card hover/secondary images only when the pointer enters a card.
 * Keeps them from competing with LCP on collection grids.
 */
(function () {
  function activate(img) {
    if (!img || img.getAttribute('data-secondary-loaded') === 'true') return;

    var srcset = img.getAttribute('data-srcset');
    var src = img.getAttribute('data-src');
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.setAttribute('data-secondary-loaded', 'true');
  }

  function activateFromEvent(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var card = target.closest('.card-wrapper');
    if (!card) return;
    var img = card.querySelector('img.card__media-secondary[data-src]');
    if (img) activate(img);
  }

  document.addEventListener('pointerover', activateFromEvent, { passive: true });
  document.addEventListener('focusin', activateFromEvent);
})();
